module.exports = __webpack_public_path__ + "ea40af4cefc470f281aaebf1e0aa4e8a.png";